module.exports = __webpack_public_path__ + "img/show-answer.d7e91d0f.png";